import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const INCIDENTDETECTION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.IncidentDetection.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.IncidentDetection.Code')
    .maxLength(10)
    .build(),
];

export const INCIDENTDETECTION_CONFIG = {
  entityName: 'IncidentDetection',
  localizationKey: 'Planning::Entity.IncidentDetection',
  fields: INCIDENTDETECTION_FIELDS,
  permission: 'ResearchAndDevelopmentIncident.IncidentDetections',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Incident + MENU_NAME_SUFFIX,
};
